import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Category Redux States
import { GET_NOTIFICATIONS, BLUE_TICK_NOTIFICATIONS, GET_ART_NOTIFICATION_REQUEST, UPDATE_ARTNOTIFICATION_REQUEST, POST_NOTIFICATION_REQUEST, SEND_NEWSLETTER_EMAIL_REQUEST, ADD_NEWSLETTER_EMAIL_REQUEST } from "./actionTypes";
import { addNewsletterEmailSuccess, getArtNotificationsSuccess, getNotificationsFail, getNotificationsSuccess, postNotificationRequest, postNotificationSuccess, sendNewsletterEmailSuccess, updateArtNotificationsSuccess } from "./actions";

import { addNewsLetterEmailApi, getArtNotificationApi, getNotifications, postNotificationApi, putNotificationApi, putNotifications, sendNewsLetterEmailApi, updateArtNotificationApi, verifyNewsLetterEmailApi } from "helpers/backend_helper";
import { callbackify } from "util";
import moment from 'moment';
function* fetchNotifications({ payload }) {
  try {
    const response = yield call(getNotifications, payload);

    if (response.status === "failure") {
      return yield put(getNotificationsFail(response.message));
    }

    yield put(getNotificationsSuccess(response));
  } catch (error) {
    yield put(getNotificationsFail(error));
  }
}
function* onPutNotifications({ payload: { data, callback } }) {
  try {
    const response = yield call(putNotifications, data);
    response.data.map((tr) => {
      let localtime = moment.unix(tr.created_date).local()
      tr.created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      return tr;
    })
    callback && callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* onGetArtNotification({ payload: { data, callback } }) {
  try {
    const response = yield call(getArtNotificationApi, data);
    response.data.map((tr) => {
      let localtime = moment.unix(tr.created_date).local()
      tr.created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      return tr;
    })
    yield put(getArtNotificationsSuccess(response));
    callback && callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* onUpdateArtNotification({ payload: { data, callback } }) {
  try {
    const response = yield call(updateArtNotificationApi, data);
    yield put(updateArtNotificationsSuccess(response));
    callback && callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* onPostNotification({ payload: { data, callback } }) {
  try {
    const response = yield call(postNotificationApi, data);
    yield put(postNotificationSuccess(response));
    callback && callback(response);
  } catch (error) {
  }
}
function* sendNewsLetterEmail({ payload: { data, callback } }) {
  try {
    const response = yield call(sendNewsLetterEmailApi, data);
    yield put(sendNewsletterEmailSuccess(response));
    callback && callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* verifyNewsLetterEmail({ payload: { data, callback } }) {
  try {
    const response = yield call(verifyNewsLetterEmailApi, data);
    yield put(addNewsletterEmailSuccess(response));
    callback && callback(response);
  } catch (error) {
    console.log(error);
  }
}
function* NotificationsSaga() {
  yield takeEvery(GET_NOTIFICATIONS, fetchNotifications);
  yield takeEvery(BLUE_TICK_NOTIFICATIONS, onPutNotifications);
  yield takeEvery(GET_ART_NOTIFICATION_REQUEST, onGetArtNotification);
  yield takeLatest(UPDATE_ARTNOTIFICATION_REQUEST, onUpdateArtNotification);
  yield takeLatest(POST_NOTIFICATION_REQUEST, onPostNotification);
  yield takeLatest(SEND_NEWSLETTER_EMAIL_REQUEST, sendNewsLetterEmail);
  yield takeLatest(ADD_NEWSLETTER_EMAIL_REQUEST, verifyNewsLetterEmail);
}

export default NotificationsSaga;